import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, Form, Input, Row, Col, Typography } from "antd";
import { getErrorProps } from "@utils/helpers";
import { ButtonComponent, InputText } from "@comps/components";
import { signinUser } from "../authSlice";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import ForgetPassword from "./ForgetPassword";
import "./SignIn.css";

const { Title, Text } = Typography;


let credentials = {};

const SignIn = () => {
  const dispatch = useDispatch();
  const { loaderState, errors } = useSelector((state) => state.auth);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [passwordInputFocused, setPasswordInputFocused] = useState(false);
  const [passwordLength, setPasswordLength] = useState(0);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [emailInputFocused, setEmailInputFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    handleLoading(errors);
  }, [errors]);

//  const getGeoLatLog=() =>{
//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//           console.log("Latitude:", position.coords.latitude);
//           console.log("Longitude:", position.coords.longitude);
//       },
//       (error) => message.info(error.message),
//       { enableHighAccuracy: true }
//   );
  
//   }
  const handleLoading = (errors) => {
    if (errors && errors.email !== undefined) {
      setLoading(false);
    }
    if (errors && errors.email === undefined && credentials.email !== undefined) {
      setLoading(true);
    }
    if (errors && errors.email === undefined && credentials.email === undefined) {
      setLoading(false);
    }
  };
  const showForgotPasswordModal = () => {
    setForgotPasswordVisible(true);
  };

  const closeForgotPasswordModal = () => {
    setForgotPasswordVisible(false);
  };

  const handleLoginSubmit = (data) => {
    credentials.email = data.email;
    credentials.password = data.password;
    setLoading(true);
    dispatch(signinUser(credentials));
    credentials = {};
  };

  const handlePasswordInputFocus = () => {
    setPasswordInputFocused(true);
    setEmailInputFocused(true);
  };

  const handlePasswordInputBlur = () => {
    setPasswordInputFocused(false);
    setEmailInputFocused(false);
  };

  const checkPasswordLength = (password) => {
    const length = password.trim().length;
    setPasswordLength(length);
  };

  const checkEmailValidity = (email) => {
    const isValid = /@/.test(email);
    setIsEmailValid(isValid);
  };

  return (
    <div className="signInPage">
      <Row className="signInLayout">
        <Col xs={{ span: 0 }} lg={{ span: 13 }} xl={{ span: 14 }} className="signInShowcaseCol">
          <div className="signInShowcase">
            <div className="signInBrand">
              <img src="loginicon/image170.svg" alt="KLOK logo" />
              <div className="signInBrandText">
                <h1>KLOK</h1>
                <p>Human resources management that keeps operations clear, connected, and easier to run every day.</p>
              </div>
            </div>

            <div className="signInFeaturePanel">
              <span className="signInBadge">Smart HR Workspace</span>
              <h2>Run your people operations from one polished control center.</h2>
              <p>
                Manage attendance, employee records, payroll workflows, and team visibility with a cleaner experience built for modern HR teams.
              </p>
              <div className="signInHighlights">
                <span>Attendance Tracking</span>
                <span>Payroll Simplified</span>
                <span>Employee Records</span>
              </div>
            </div>

            <div className="signInPreview">
              <img src="loginicon/dashboard_screenshot1.png" alt="KLOK dashboard preview" />
            </div>
          </div>
        </Col>

        <Col xs={{ span: 24 }} lg={{ span: 11 }} xl={{ span: 10 }} className="signInFormCol">
          <div className="signInFormShell">
            <div className="signInCard">
              <div className="signInCardHeader">
                <img src="loginicon/image170.svg" alt="not found" />
                <img src="loginicon/KLOK.svg" alt="not found" />
              </div>

              <Title className="signInHeading">Welcome back</Title>
              <Text className="signInSubtitle">
                Sign in to continue to your HR workspace and pick up right where you left off.
              </Text>

              <Form
                layout="vertical"
                name="basic"
                initialValues={{ remember: true }}
                className="signInForm"
                onFinish={handleLoginSubmit}
              >
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Please input your email!" },
                  ]}
                  label="Username or Email"
                  className="da-mb-16"
                  {...getErrorProps(errors ? errors.email : "")}
                >
                  <InputText
                    placeholder="Enter your Username or Email"
                    style={{ height: 56 }}
                    prefix={
                      <MailOutlined
                        className={`mail-icon ${emailInputFocused ? "focused" : ""} ${isEmailValid ? "" : "error"}`}
                      />
                    }
                    onFocus={handlePasswordInputFocus}
                    onBlur={handlePasswordInputBlur}
                    onChange={(e) => checkEmailValidity(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                    { min: 6, message: "Minimum password length is 6" },
                    { max: 30, message: "Maximum password length is 30" },
                  ]}
                  label="Password"
                  className="da-mb-8"
                  {...getErrorProps(errors ? errors.password : "")}
                >
                  <Input.Password
                    type="password"
                    placeholder="Enter your Password"
                    style={{ height: 56 }}
                    prefix={
                      <LockOutlined
                        className={`lock-icon ${passwordInputFocused ? "focused" : ""} ${passwordLength > 0 && passwordLength < 6 ? "error" : ""}`}
                      />
                    }
                    onFocus={handlePasswordInputFocus}
                    onBlur={handlePasswordInputBlur}
                    onChange={(e) => checkPasswordLength(e.target.value)}
                  />
                </Form.Item>

                <div className="signInOptions">
                  <Form.Item className="da-mb-0">
                    <Checkbox name="remember">Remember me</Checkbox>
                  </Form.Item>

                  <button
                    type="button"
                    className="signInForgotLink"
                    onClick={showForgotPasswordModal}
                    style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer" }}
                  >
                    Forgot Password?
                  </button>
                </div>

                <Form.Item className="da-mt-16 da-mb-8">
                  <ButtonComponent className="actionButton" type="primary" htmlType="submit" state={loaderState} loading={loading}>
                    Log in
                  </ButtonComponent>
                </Form.Item>
              </Form>
              <ForgetPassword
                visible={forgotPasswordVisible}
                onCancel={closeForgotPasswordModal}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignIn;
